import './index.css';

import type Sentry from '@sentry/browser';
import { Buffer } from 'buffer';
import React from 'react';
import ReactDOM from 'react-dom';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { ScrollToTop } from './components/scroll/scroll-top.component';
import { intercomAppId } from './config';
import { Contexts } from './contexts/contexts';
import reportWebVitals from './reportWebVitals';

const TOAST_OPTIONS = {
  duration: 5000,
  style: {
    fontFamily: 'NotoSans',
    fontWeight: 700,
  },
  success: {
    iconTheme: {
      primary: 'black',
      secondary: 'white',
    },
  },
};

declare global {
  interface Window {
    Sentry?: typeof Sentry;
    Buffer: typeof Buffer;
  }
}

window.Buffer = Buffer;

window.Intercom('boot', {
  app_id: intercomAppId,
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Contexts>
        <ScrollToTop />
        <App />
        <Toaster toastOptions={TOAST_OPTIONS} />
      </Contexts>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
